import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonCancel: React.FC<MprcButtonProps> = ({ text, title, variant = "contained", color = "cancel", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonCancel.text;
    const lTitle = title || theme.buttons.ButtonCancel.title;
    return (
        <MprcButton
            {...rest}
            variant={variant}
            color={color}
            title={lTitle}
            text={lText}
        />
    );
};
